<template>
  <Modal
    class="tooltip-modal"
    data-testid="tooltip-modal"
    :is-open="isOpen"
    :show-back-button="false"
    size="md"
    title=""
    @close="handleClose"
  >
    <div class="tooltip-modal__content">
      <Heading class="tooltip-modal__heading" :level="3">{{ title }}</Heading>
      <BaseText
        class="tooltip-modal__text"
        size="sm"
        :color="NebraskaColors.elementSecondary"
        >{{ description }}</BaseText
      >
    </div>
  </Modal>
</template>

<script lang="ts" setup>
import { Modal, Heading, BaseText } from '@warrenbrasil/nebraska-web';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface Props {
  isOpen: boolean;
  title: string;
  description: string;
}
defineProps<Props>();

interface Emits {
  (e: 'close'): void;
}
const emit = defineEmits<Emits>();

const handleClose = () => {
  emit('close');
};
</script>

<style lang="less" scoped>
.tooltip-modal {
  ::v-deep .modal-content {
    padding: 0 @size-spacing-x900 @size-spacing-x900 @size-spacing-x900;
  }

  &__heading,
  &__text {
    text-align: left;
  }

  &__heading {
    margin-bottom: @size-spacing-x350;
  }

  &__content {
    display: flex;
    width: 100%;
    justify-content: flex-start;
    flex-direction: column;
  }
}
</style>
